import { Store } from 'redux';

export function observeStore<ROOT_STATE, SELECT_STATE>(
  store: Store,
  select: (rootState: ROOT_STATE) => SELECT_STATE,
  onChange: (selectedState: SELECT_STATE) => void
) {
  let currentState: SELECT_STATE;

  function handleChange() {
    let nextState = select(store.getState());
    if (nextState !== currentState) {
      currentState = nextState;
      onChange(currentState);
    }
  }

  let unsubscribe = store.subscribe(handleChange);
  handleChange();
  return unsubscribe;
}
